


import Formulario from '../../components/votantes/tabla'
import React, { useEffect, useState } from "react";


export default function Paginas() {
  


   
            return (
                <>
           
              <div  >
        <br/>
                <Formulario/>
                
                </div>
              
     
                
          
                </>
           
            );
        
        }